<template>
  <div class="scan-code" :class="{ 'scan-height': scanCode }">
    <!-- <img src="@/assets/images/top.png" alt="" class="small-code" @click="scanCodeClick"> -->
    <div id="wx_qr_login" v-show="scanCode && !isBind"></div>
    <div v-show="scanCode && isBind">
      <h1 class="forget-title bind_title">微信登录绑定</h1>
      <el-form hide-required-asterisk :model="msg" :rules="forgetPwdRules" ref="forgetLoginFormRef" class="login_from">
        <el-form-item prop="phone" label="手机号" label-width="100%">
          <el-input placeholder="手机号" v-model="msg.phone"></el-input>
        </el-form-item>
        <el-form-item prop="code" label="验证码" label-width="100%" class="verification-code">
          <el-input style="width:169px;" placeholder="验证码" v-model="msg.code" type="text"></el-input>
          <getCodeBtn ref="getCodeBtn" @click.native="forgetGetCode" />
          <!-- <el-button @click="forgetGetCode" :disabled='forgetBtn' :class="{'bg-text':forgetBtn}">{{ forgettext }}</el-button> -->
        </el-form-item>
        <div class="login_btn">
          <el-button @click="bangding">绑定</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import getCodeBtn from '@/components/getCodeBtn.vue'
import { codeSms, openUserWxRegister, checkCode } from '@/api/crm'
export default {
  components: {
    getCodeBtn
  },
  data () {
    return {
      isBind: false,
      forgetBtn: false,
      forgettext: '获取验证码',
      scanCode: false,
      msg: {
        code: '',
        password: '',
        phone: '',
        passwordAgain: ''
      },
      forgetPwdRules: {
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    show () {
      this.scanCode = true
      this.isBind = true
    },
    getWxQr () {
      let url = process.env.NODE_ENV === 'production'
        ? 'https://www.piyaps.com'
        : 'http://test3.kencoo.com'
      // eslint-disable-next-line no-undef
      var obj = new WxLogin({
        self_redirect: false,
        id: 'wx_qr_login',
        appid: 'wxb392d9416aa7b5a1',

        scope: 'snsapi_login',

        redirect_uri: encodeURIComponent(url + '/api/crm/open/redirect/respWx?type=ADMIN'),

        state: 'A123DC35165464',

        style: 'black',

        href: 'data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDE1cHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMjMwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQ=='

      })
    },
    scanCodeClick () {
      this.scanCode = true
      this.scanCode && this.getWxQr()
    },
    bangding () {
      this.$refs.forgetLoginFormRef.validate((valid) => {
        if (!valid) {
          return
        }
        // 二维码登录绑定
        checkCode({
          phone: this.msg.phone,
          code: this.msg.code,
          type: 'LOGIN'
        })
          .then(res => {
            if (res.data.success) {
              openUserWxRegister({
                type: 'ADMIN',
                username: this.msg.phone
              })
                .then(res => {
                  if (res.data.success) {
                    this.getWxQr()
                    this.isBind = false
                  }
                })
            }
          })
      })
    },
    forgetGetCode () {
      this.$refs.forgetLoginFormRef.validateField('phone', errorMessage => {
        if (errorMessage) return false
        this.$refs.getCodeBtn.getCode(this.msg.phone, 'LOGIN')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.small-code {
  width: 40px;
  float: right;
}

.scan-height {
  height: 100%;
  width: 100%;
}

.bind_title {
  margin: 30px 0 29px 30px !important;
}
</style>
